import React, { useState } from 'react';
import NineSlice from './NineSlice';

const BUILDINGS_NORMAL = [
  '/assets/buildings/house1_blue.png',
  '/assets/buildings/house2_blue.png',
  '/assets/buildings/barracks_blue.png',
  '/assets/buildings/house3_blue.png',
  '/assets/buildings/monastery_blue.png',
  '/assets/buildings/archery_blue.png',
  '/assets/buildings/tower_blue.png',
  '/assets/buildings/house1_blue.png',
  '/assets/buildings/house2_blue.png',
  '/assets/buildings/barracks_blue.png',
];
const BUILDINGS_KEY = [
  '/assets/buildings/castle_yellow.png',
  '/assets/buildings/tower_yellow.png',
  '/assets/buildings/monastery_yellow.png',
];

// 데모용 클리어 날짜 (하드코딩)
const CLEARED_DATES = [
  '2025.06.02', '2025.06.03', '2025.06.05', '2025.06.06',
  '2025.06.09', '2025.06.10', '2025.06.11', '2025.06.12',
  '2025.06.13', '2025.06.16',
];

function LearningMap({ missions, onMissionClick }) {
  const [hoveredIdx, setHoveredIdx] = useState(null);
  const [clearedCount, setClearedCount] = useState(3); // 데모: 3개 클리어
  const totalScore = missions.reduce((s, m) => s + m.missionScore, 0);
  const clearedScore = missions.slice(0, clearedCount).reduce((s, m) => s + m.missionScore, 0);
  const count = missions.length;
  let keyIdx = 0;

  // bg.png 섬의 초록 영역 위에 S자로 배치
  // 섬 형태에 맞춰 수동 좌표 (% 단위, hmap-world 기준)
  const ISLAND_COORDS = [
    { x: 15, y: 24 },  // 1 - 좌상단 섬 (START)
    { x: 35, y: 22 },  // 2 - 상단 중앙
    { x: 58, y: 25 },  // 3 - 우상단
    { x: 77, y: 26 },  // 4 - 우상
    { x: 65, y: 42 },  // 5 - 우중
    { x: 48, y: 38 },  // 6 - 중앙
    { x: 25, y: 45 },  // 7 - 좌중
    { x: 12, y: 62 },  // 8 - 좌하
    { x: 35, y: 72 },  // 9 - 하단 중앙
    { x: 60, y: 68 },  // 10 - 우하
    { x: 72, y: 58 },  // 11 (BOSS) - 우하단
  ];

  const positions = missions.map((_, i) => {
    if (i < ISLAND_COORDS.length) return ISLAND_COORDS[i];
    // 미션이 더 많으면 마지막 좌표 부근에 배치
    const last = ISLAND_COORDS[ISLAND_COORDS.length - 1];
    return { x: last.x, y: last.y + (i - ISLAND_COORDS.length + 1) * 5 };
  });

  // 섬 위 장식 (나무, 관목, 바위 — 건물 사이 빈 공간에 배치)
  const islandDecos = [
    // 나무 — 건물 사이 초록 영역
    { img: '/assets/decorations/Tree1.png', x: 26, y: 22, w: 55 },
    { img: '/assets/decorations/Tree2.png', x: 32, y: 28, w: 50 },
    { img: '/assets/decorations/Tree3.png', x: 68, y: 55, w: 55 },
    { img: '/assets/decorations/Tree4.png', x: 22, y: 72, w: 50 },
    { img: '/assets/decorations/Tree1.png', x: 42, y: 52, w: 48 },
    { img: '/assets/decorations/Tree2.png', x: 85, y: 38, w: 45 },
    // 관목 — 건물 근처 작은 장식
    { img: '/assets/decorations/bush1.png', x: 20, y: 32, w: 22 },
    { img: '/assets/decorations/bush2.png', x: 52, y: 25, w: 20 },
    { img: '/assets/decorations/bush3.png', x: 38, y: 60, w: 20 },
    { img: '/assets/decorations/bush1.png', x: 75, y: 68, w: 22 },
    { img: '/assets/decorations/bush2.png', x: 15, y: 52, w: 18 },
    { img: '/assets/decorations/bush3.png', x: 62, y: 32, w: 18 },
    // 바위/그루터기 — 포인트 장식
    { img: '/assets/decorations/rock1.png', x: 45, y: 48, w: 20 },
    { img: '/assets/decorations/Stump 1.png', x: 55, y: 58, w: 18 },
    { img: '/assets/decorations/rock1.png', x: 30, y: 82, w: 16 },
    { img: '/assets/decorations/Stump 2.png', x: 82, y: 48, w: 16 },
  ];

  return (
    <div className="hmap">
      {/* 배너 — 9-Slice Paper */}
      <NineSlice preset="paperWide" className="hmap-banner-ns" style={{ width: '100%', maxWidth: 540, margin: '0 auto 10px', height: 95 }}>
        <h2 className="hmap-banner-title">1단원 · 각도 대모험</h2>
        <div className="hmap-banner-info">
          <span>미션 {clearedCount}/{count}</span>
          <span>⭐ {clearedScore}/{totalScore}점</span>
          <span className="gold-text">🔑 핵심 {missions.filter(m => m.isKey).length}개</span>
        </div>
        {/* 진행도 바 */}
        <div className="hmap-progress-bar">
          <div className="hmap-progress-fill" style={{ width: `${(clearedCount / count) * 100}%` }} />
        </div>
      </NineSlice>

      {/* 데모 슬라이더 — 진행도 조절 */}
      <div className="hmap-demo-slider">
        <label>진행도 데모: </label>
        <input type="range" min={0} max={count} value={clearedCount}
          onChange={e => setClearedCount(Number(e.target.value))} />
        <span>{clearedCount}/{count} 클리어</span>
      </div>

      {/* 범례 */}
      <div className="hmap-legend">
        <div className="hmap-legend-item"><div className="legend-sq normal" />일반</div>
        <div className="hmap-legend-item"><div className="legend-sq key" />핵심 (보너스)</div>
        <div className="hmap-legend-item"><div className="legend-sq boss" />BOSS</div>
      </div>

      {/* 맵 */}
      <div className="hmap-world">
        {/* 타일맵 배경 (bg.png — 섬+바다) */}
        <div className="hmap-bg" style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/frames/bg.png)`,
        }} />

        {/* 구름 — bg.png에 이미 포함됨 */}

        {/* 섬 영역 (건물/장식 배치 기준) */}
        <div className="hmap-island">

          {/* 나무/관목/바위 장식 */}
          {islandDecos.map((d, i) => (
            <img key={`d-${i}`} src={d.img} alt="" className="hmap-deco"
              style={{ left: `${d.x}%`, top: `${d.y}%`, width: d.w }} />
          ))}

          {/* 경로 SVG */}
          <svg className="hmap-path-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
            {positions.map((pos, idx) => {
              if (idx === 0) return null;
              const prev = positions[idx - 1];
              const midX = (prev.x + pos.x) / 2;
              const isCleared = idx < clearedCount;
              const isCurrent = idx === clearedCount;
              return (
                <path key={`p-${idx}`}
                  d={`M ${prev.x} ${prev.y} C ${midX} ${prev.y}, ${midX} ${pos.y}, ${pos.x} ${pos.y}`}
                  fill="none"
                  stroke={isCleared ? '#4CAF50' : isCurrent ? '#FFB300' : '#6B4E1E'}
                  strokeWidth={isCleared ? '1.8' : '0.8'}
                  strokeDasharray={isCleared ? 'none' : '1.5 1'}
                  opacity={isCleared ? 0.9 : 0.35} />
              );
            })}
          </svg>

          {/* 캐릭터 — 현재 미션 위치 */}
          {(() => {
            const playerIdx = Math.min(clearedCount, count - 1);
            const playerPos = positions[playerIdx];
            return (
              <img src="/assets/units/lancer_blue.png" alt="player" className="hmap-player"
                style={{
                  left: `calc(${playerPos.x}% - 22px)`,
                  top: `calc(${playerPos.y}% - 50px)`,
                }} />
            );
          })()}

          {/* 미션 노드 */}
          {missions.map((mission, idx) => {
            const pos = positions[idx];
            const isKey = mission.isKey;
            const isLast = idx === count - 1;
            const isFirst = idx === 0;
            const isHovered = hoveredIdx === idx;
            const isCleared = idx < clearedCount;
            const isCurrent = idx === clearedCount;
            const isLocked = idx > clearedCount;

            let buildingImg;
            if (isLast) {
              buildingImg = '/assets/buildings/castle_red.png';
            } else if (isKey) {
              buildingImg = BUILDINGS_KEY[keyIdx++ % BUILDINGS_KEY.length];
            } else if (isFirst) {
              buildingImg = '/assets/buildings/house1_purple.png';
            } else {
              buildingImg = BUILDINGS_NORMAL[idx % BUILDINGS_NORMAL.length];
            }

            // 미션 순서에 따라 점점 커짐 (60px → BOSS 120px)
            const progress = idx / (count - 1); // 0 ~ 1
            const baseSize = isLast ? 120 : Math.round(60 + progress * 50);
            const bSize = isKey ? baseSize + 10 : baseSize;

            const nodeClass = [
              'hmap-node',
              isHovered ? 'hmap-node-hover' : '',
              isCleared ? 'hmap-node-cleared' : '',
              isCurrent ? 'hmap-node-current' : '',
              isLocked ? 'hmap-node-locked' : '',
            ].filter(Boolean).join(' ');

            return (
              <div key={mission.order}
                className={nodeClass}
                style={{
                  left: `calc(${pos.x}% - ${bSize / 2}px)`,
                  top: `calc(${pos.y}% - ${bSize / 2}px)`,
                  width: bSize,
                }}
                onClick={() => onMissionClick(mission)}
                onMouseEnter={() => setHoveredIdx(idx)}
                onMouseLeave={() => setHoveredIdx(null)}
              >
                {/* 현재 미션 펄스 링 */}
                {isCurrent && <div className="hmap-pulse-ring" style={{ width: bSize + 30, height: bSize + 30 }} />}
                {isKey && isCleared && <div className="hmap-glow" />}
                {isLast && <div className="hmap-glow hmap-glow-boss" />}
                <div className={`hmap-ground ${isLast ? 'hmap-ground-boss' : isKey ? 'hmap-ground-key' : ''}`}
                  style={{ width: bSize, height: bSize * 0.45 }} />
                <img src={buildingImg} alt="" className="hmap-building" style={{ width: bSize, height: bSize }} />

                {/* 클리어 — 방패 아이콘 */}
                {isCleared && (
                  <div className="hmap-cleared-mark">
                    <img src="/assets/ui/Icon_06.png" alt="cleared" />
                  </div>
                )}

                {/* 잠금 — X 아이콘 */}
                {isLocked && (
                  <div className="hmap-lock-icon">
                    <img src="/assets/ui/Icon_09.png" alt="locked" />
                  </div>
                )}

                <div className={`hmap-badge ${isKey ? 'hmap-badge-key' : ''} ${isLast ? 'hmap-badge-boss' : ''}`}>
                  {isFirst ? 'START' : isLast ? 'BOSS' : mission.order}
                </div>

                <div className="hmap-score">
                  <img src="/assets/ui/Icon_03.png" alt="" className="hmap-score-icon" />
                  {mission.missionScore}
                </div>

                {/* 호버 툴팁 — 양피지 + 아이콘 */}
                <div className={`hmap-tooltip ${isHovered ? 'show' : ''} ${pos.x > 75 ? 'hmap-tooltip-left' : ''} ${pos.x < 15 ? 'hmap-tooltip-right' : ''}`}
                  style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/frames/paper_medium.png)` }}>
                  {/* 상태 표시 */}
                  {isCleared && (
                    <div className="tt-status tt-status-cleared">
                      <img src="/assets/ui/Icon_06.png" alt="" className="tt-status-icon" />
                      <span className="tt-status-text">{CLEARED_DATES[idx] || '완료'}</span>
                    </div>
                  )}
                  {isCurrent && (
                    <div className="tt-status tt-status-current">
                      <img src="/assets/ui/Icon_07.png" alt="" className="tt-status-icon" />
                      <span className="tt-status-text">도전 중!</span>
                    </div>
                  )}
                  {isLocked && (
                    <div className="tt-status tt-status-locked">
                      <img src="/assets/ui/Icon_09.png" alt="" className="tt-status-icon" />
                      <span className="tt-status-text">잠김</span>
                    </div>
                  )}
                  {isKey && (
                    <div className="tt-status tt-status-key">
                      <img src="/assets/ui/Icon_03.png" alt="" className="tt-status-icon" />
                      <span className="tt-status-text">핵심 미션!</span>
                    </div>
                  )}

                  <div className="tt-topic">{mission.topic}</div>
                  <div className="tt-divider" />

                  {/* 메타 정보 — 아이콘 기반 */}
                  <div className="tt-meta-row">
                    <div className="tt-meta-item">
                      <img src="/assets/ui/Icon_05.png" alt="문항" className="tt-meta-icon" />
                      <span>{mission.totalItems}</span>
                    </div>
                    <div className="tt-meta-item">
                      <img src="/assets/ui/Icon_03.png" alt="점수" className="tt-meta-icon" />
                      <span>{mission.missionScore}</span>
                    </div>
                    {mission.bonusMultiplier > 1 && (
                      <div className="tt-meta-item">
                        <img src="/assets/ui/Icon_06.png" alt="배율" className="tt-meta-icon" />
                        <span>x{mission.bonusMultiplier}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 하단 */}
      <div className="hmap-footer">
        <img src="/assets/ui/Avatar1.png" alt="" className="hmap-footer-char" />
        <div>
          <p><strong>건물을 클릭</strong>하면 미션 상세를 볼 수 있어요!</p>
          <p>🔑 핵심 미션은 반드시 클리어하세요!</p>
        </div>
      </div>
    </div>
  );
}

export default LearningMap;
